import { BaseApi, type PaginatedResponse, type BaseRequestConfig } from '@bv/api';
import { mixinClass } from '@bv/utils/common/mixin-class';

/**
 * Manages AI agent call interaction reports.
 */
class AiAgentReportApi extends mixinClass(BaseApi) {
  public constructor(public endpoint = 'ai-agent/reports/calls') {
    super(endpoint);
  }

  public async paginated(config: BaseRequestConfig = {}): Promise<PaginatedResponse<AiAgentReportData>> {
    return this.request<AiAgentReportData, PaginatedResponse<AiAgentReportData>>({
      method: 'get',
      params: config.params,
      headers: config.headers,
      data: config.data,
    });
  }

  public async exportToEmail(config: BaseRequestConfig = {}): Promise<any> {
    return this.request({
      method: 'get',
      url: 'export',
      data: config.data,
      headers: config.headers,
      params: config.params,
    }).then((response) => response.data);
  }
}

export const aiAgentReportApi = new AiAgentReportApi();
